export default {
    install (Vue) {
        // 全局请求方法
        Vue.prototype.$request = (obj) => {
            return new Promise((resolve, reject) => {
                Vue.prototype.$axios({
                    url: obj.url,
                    method: obj.method || 'POST',
                    headers: obj.headers,
                    // POST && PUT 参数方式
                    data:  obj.data,
                    // GET && DELETE 参数方式
                    params: obj.params
                })
                .then((res) => {
                    resolve(res.data)
                })
                .catch((error) => {
                    reject(error)
                })
            })
        }
    }
}